import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Row, Form, Modal, Card, Col } from "reactstrap"
import Select from "react-select"
// assets
import Loader from "pages/Separate/Loader"
import "../../../../assets/css/Sales/Sales.css"
import userImg from "../../../../assets/images/users/avatar-1.jpg"
import axios from "axios"
import swal from "sweetalert"
import moment from "moment"
import configure from "configure"
import Swal from "sweetalert2"
import { Tooltip } from "antd"
import { convertTimeZone } from "utils/common-helpers"
import { fetchNodeData, FetchNodePostData, FetchNodePutData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import { useSelector } from "react-redux"

const BiddingFollowUp = ({ verticalActiveTab }) => {
    const [fixButtons, setFixButtons] = useState(false)
    const [notesSidebar, setNotesSidebar] = useState(false)
    const [editNotesSidebar, setEditNotesSidebar] = useState(false)
    const [loading, setLoading] = useState(false)
    const generalData = useSelector(state => state?.GeneralData?.generalData)

    const [data, setDatas] = useState([])
    const navigate = useNavigate()
    const params = useParams()

    document.addEventListener("scroll", () => {
        if (window.scrollY > 160) {
            setFixButtons(true)
        } else {
            setFixButtons(false)
        }
    })
    const token = secureLocalStorage.getItem('auth_token')
    useEffect(() => {
        const fetchNotes = async () => {
            const res = await fetchNodeData(setLoading, `biddingFollowups/${params.id}`, token)
            console.log(res)
            if (res?.status == 200) {
                setDatas(res?.data)
            }
        }
        if (verticalActiveTab == '3') {
            fetchNotes()
        }
    }, [verticalActiveTab])

    const [assign, setAssigned] = useState([])
    const [notedate, setNotedate] = useState("")
    const [description, setDescription] = useState("")

    const addNotes = async e => {
        e.preventDefault()
        const formEntries = {
            bidding_id: params?.id,
            description: description,
            user_id: localStorage.getItem('auth_id'),
            assignee: assign?.value,
            date: notedate
        };
        const res = await FetchNodePostData(setLoading, 'biddingFollowups', token, formEntries);
        if (res?.data?.status == 200) {
            setDatas(res.data.data)
            setNotesSidebar(false)
            setNotedate('')
            setDescription('')
            setAssigned([])
        }
    }

    const deleteNote = async (e, note_id) => {
        swal({
            title: "Are you sure?",
            text: "You want to Delete this Follow Up !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async willdelete => {
            if (willdelete) {
                e.preventDefault()
                setLoading(true)
                const formData = {
                    bidding_id: params.id
                }
                try {
                    await axios({
                        method: "delete",
                        url: `${configure.nodeApi}/biddingFollowups/${note_id}`,
                        data: formData,
                        headers: {
                            Accept: "application/json",
                        },
                    }).then(res => {
                        setLoading(false)
                        Swal.fire({
                            icon: "success",
                            text: "Follow Up has been deleted successfully !",
                        }).then(data => {
                            setDatas(res.data.data)
                        })
                    })
                } catch (error) {
                    console.log(error)
                    setLoading(false)
                }
            }
        })
    }

    const colourStyles = {
        menuList: styles => ({
            ...styles,
            background: "white",
        }),
        menu: base => ({
            ...base,
            zIndex: 50,
        }),
    }

    const [edit_description, setEditDescription] = useState("")
    const [edit_assign, setEditAssign] = useState([])
    const [edit_date, setEditDate] = useState("")
    const [follow_id, setFollowId] = useState("")

    const editNotes = async (e) => {
        e.preventDefault()
        const formEntries = {
            description: edit_description,
            assignee: edit_assign?.value,
            date: edit_date,
            bidding_id: params?.id,
        };
        const res = await FetchNodePutData(setLoading, `biddingFollowups`, follow_id, formEntries);
        if (res?.data?.status == 200) {
            setDatas(res.data.data)
            setEditNotesSidebar(false)
            setEditAssign([])
            setEditDate('')
            setEditDescription('')
        }
    }

    return (
        <React.Fragment>
            {loading && <Loader />}
            <div className="mb-3">
                <div className="px-3 py-4 bg-white">
                    {/* Fixed Buttons */}
                    <div
                        className={`flex-column fixed-buttons ${fixButtons ? "d-flex" : "d-none"
                            }`}
                    >
                        <a
                            onClick={() => setNotesSidebar(true)}
                            className="btn btn-purple  fix-btn"
                        >
                            <i className="fas fa-plus me-2"></i>
                            <span>Note</span>
                        </a>
                        <a onClick={() => navigate(-1)} className="btn btn-red  fix-btn">
                            <i className="dripicons-cross me-2 icon-center"></i>
                            <span>Cancel</span>
                        </a>
                    </div>
                    <div className="d-flex justify-content-between">
                        <h5 className="text-dark">Add Follow Up</h5>
                        <div className="text-end">
                            <a
                                onClick={() => setNotesSidebar(true)}
                                className=" btn btn-save btn-label "
                            >
                                <i className="fas fa-plus me-2 icon-size label-icon"></i>Add
                                FollowUp
                            </a>
                            <a
                                onClick={() => navigate(-1)}
                                className=" btn ms-md-2 btn-red btn-label"
                            >
                                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                                CANCEL
                            </a>
                        </div>
                    </div>
                    {/* Add Notes Sidebar */}
                    <div
                        className={`notes-sidebar ${notesSidebar ? "show-notes-sidebar" : ""
                            }`}
                    >
                        <Form onSubmit={addNotes}>
                            <Row className="align-items-center ">
                                <div className="col-12 d-flex justify-content-between">
                                    <h5>Add New FollowUp</h5>
                                    <div className="text-end">
                                        <button className="btn btn-purple  me-2">
                                            <i className="fas fa-plus me-2"></i>Add FollowUp
                                        </button>
                                        <a
                                            onClick={() => setNotesSidebar(false)}
                                            className="btn btn-red text-uppercase "
                                        >
                                            <i className="dripicons-cross me-1 icon-center"></i>Close
                                        </a>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-3 notes">
                                    <label htmlFor="touch">
                                        FollowUp Date <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        required
                                        value={notedate}
                                        onChange={e => setNotedate(e.target.value)}
                                        className="form-control "
                                    />
                                </div>
                                <div className="col-md-4 mt-4">
                                    <label htmlFor="">Assigned</label>
                                    <Select
                                        placeholder="Select"
                                        className="basic-multi-select"
                                        classNamePrefix=" select"
                                        value={assign}
                                        styles={colourStyles}
                                        options={generalData?.staff}
                                        onChange={e => setAssigned(e)}
                                    />
                                </div>

                                <div className="col-12 mt-4">
                                    <label htmlFor="">Purpose</label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Enter Purpose"
                                        onChange={e => setDescription(e.target.value)}
                                        style={{ height: "65px" }}
                                    ></textarea>
                                </div>
                            </Row>
                        </Form>
                    </div>

                    <div className="mt-4">
                        <ul className="verti-timeline list-unstyled notes-box">
                            {data?.map((note, key) => {
                                const filteredArray = generalData?.staff.find((obj) => obj?.value == note?.assignee)?.label
                                return (
                                    <li key={key} className="event-list position-relative">
                                        <div className="event-timeline-dot">
                                            <img
                                                src={`${configure.imgUrl}${note.avatar}`}
                                                className="userImg me-3 "
                                                alt=""
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                                                <div className=" d-flex justify-content-between ">
                                                    <div>
                                                        <p className="text-muted cursor-pointer">
                                                            <h6 className="d-inline me-2">
                                                                By {note.added_by}
                                                            </h6>{" "}
                                                            <Tooltip
                                                                color="#f0e8f4"
                                                                title={
                                                                    <div className="text-purple fw-bold body-font fs-6">
                                                                        <div>UK Time: {convertTimeZone(note.created_at, "Europe/London", "DD-MM-YYYY hh:mm:ss a")}</div>
                                                                        <div>US Time : {convertTimeZone(note.created_at, "America/New_York", "DD-MM-YYYY hh:mm:ss a")}</div>
                                                                    </div>
                                                                }
                                                            >
                                                                {moment(note.created_at).format(
                                                                    "DD-MM-YYYY hh:mm:ss"
                                                                )}
                                                            </Tooltip>
                                                            <span className="pl-15">
                                                                {" "}
                                                                Follow Up at{" "}
                                                                <Tooltip
                                                                    color="#f0e8f4"
                                                                    title={
                                                                        <div className="text-purple fw-bold body-font fs-6">
                                                                            <div>UK Time: {convertTimeZone(note.date_time, "Europe/London", "DD-MM-YYYY hh:mm:ss a")}</div>
                                                                            <div>US Time : {convertTimeZone(note.date_time, "America/New_York", "DD-MM-YYYY hh:mm:ss a")}</div>
                                                                        </div>
                                                                    }
                                                                >
                                                                    {moment(note.date_time).format("DD-MM-YYYY")}
                                                                </Tooltip>
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <div className="me-4">
                                                        <a
                                                            onClick={() => {
                                                                setEditNotesSidebar(true)
                                                                setFollowId(note.id)
                                                                setEditDescription(note.description)
                                                                setEditAssign(generalData?.staff?.find((obj) => obj?.value == note?.assignee))
                                                                setEditDate(moment(note.date).format('YYYY-MM-DD'))
                                                            }}
                                                            className="btn btn-sm edit-delete-btn text-success me-2"
                                                        >
                                                            <i className="fas fa-edit" title="Edit"></i>
                                                        </a>
                                                        <button
                                                            onClick={e => {
                                                                deleteNote(e, note.id)
                                                            }}
                                                            className="btn btn-sm edit-delete-btn text-danger"
                                                        >
                                                            <i
                                                                className="fas fa-trash-alt"
                                                                title="Delete"
                                                            ></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <i className="bi bi-triangle-fill note-icon"></i>

                                                <div
                                                    className="Features"
                                                    dangerouslySetInnerHTML={{
                                                        __html: note.description,
                                                    }}
                                                />
                                                <p className="mb-1">Assigned user : {filteredArray}</p>
                                            </div>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                        {data.length == 0 ? <p>FollowUp is Not Addded</p> : null}
                    </div>

                    {/* Edit Notes Sidebar */}
                    <div
                        className={`notes-sidebar ${editNotesSidebar ? "show-notes-sidebar" : ""
                            }`}
                    >
                        <form onSubmit={editNotes}>
                            <Row className="align-items-center justify-content-between">
                                <div className="col-12 d-flex justify-content-between">
                                    <h5>Edit Follow Up</h5>
                                    <div className="text-end">
                                        <button className="btn btn-purple  me-2">
                                            <i className="fas fa-edit me-2"></i>Edit FollowUp
                                        </button>
                                        <a
                                            onClick={() => setEditNotesSidebar(false)}
                                            className="btn btn-red text-uppercase "
                                        >
                                            <i className="dripicons-cross me-1 icon-center"></i>
                                            Close
                                        </a>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-3 notes">
                                    <label htmlFor="touch">
                                        FollowUp Date <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        required
                                        onChange={e => setEditDate(e.target.value)}
                                        value={edit_date}
                                        className="form-control "
                                    />
                                </div>
                                <div className="col-md-4 mt-3">
                                    <label htmlFor="">Assigned</label>
                                    <Select
                                        onChange={e => setEditAssign(e)}
                                        className="basic-multi-select"
                                        classNamePrefix=" select"
                                        styles={colourStyles}
                                        options={generalData?.staff}
                                        value={edit_assign}
                                    />
                                </div>
                                <div className="col-md-4 mt-3 text-end"></div>
                                <div className="col-12 mt-4">
                                    <label htmlFor="">Purpose</label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Enter Purpose"
                                        value={edit_description}
                                        onChange={e => setEditDescription(e.target.value)}
                                        style={{ height: "65px" }}
                                    ></textarea>
                                </div>
                            </Row>
                        </form>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default BiddingFollowUp
